import { Divider } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { TagSelector } from '../../../components/Taxonomy/TagSelector';
import { HorizontalStack, SmartContainer, Stack } from '../../../styles/Containers';
import { StyledButton } from '../../../styles/matieralui/Button';
import { StyledCircularProgress } from '../../../styles/matieralui/Progress';
import { StyledH6, StyledP } from '../../../styles/StyledHTML';
import { IconSuggestionBox } from '../../components/Content/IconSuggestion';
import { IconLocation, IconPerson, IconTag } from '../../Icons';
import { FullGenericTags } from '../GenericTags/redux/generictags.selectors';
import { FullLibraries } from '../Library/redux/library.selectors';
import { FullLocations } from '../Location/redux/locations.selectors';
import { FullPeople } from '../People/redux/people.selectors';
import { loadAsset, moveAssetToTrash, deleteAsset } from './redux/assets.actions';
import { addGenericTags, getGenericTag, searchGenericTags } from '../GenericTags/redux/generictags.actions';
import { addPeopleTags, searchPeople } from '../People/redux/people.actions';
import { addLocationTags, searchLocations } from '../Location/redux/locations.actions';
import { useDispatch } from 'react-redux';
import { FullAssets } from './redux/assets.selectors';
import { TagSelectorWithAutoComplete } from '../../../components/Taxonomy/TagSelectorWithAutoComplete';

export const BatchUpdatePreview = ({ asset, tags, people, locations }) => {
    return (
        <SmartContainer key={asset.id} flex align="center" justify="space-between">
            <StyledP>{asset.name}</StyledP>
            <StyledP light><StyledCircularProgress size="small" color="primary" /></StyledP>
        </SmartContainer>
    )
}



export const BatchUpdater = ({ assets, myRole, onCancel, onComplete, action = 'edit' }) => {

    const dispatch = useDispatch();
    const store = FullAssets();
    const storeTags = FullGenericTags();
    const storePeople = FullPeople();
    const storeLocations = FullLocations();
    const [tags, setTags] = useState([]);
    const [people, setPeople] = useState([]);
    const [locations, setLocations] = useState([]);
    const [viewState, setViewState] = useState(action);
    const [localAssets, setLocalAssets] = useState(assets)



    const handleCancel = () => {
        if (onCancel) onCancel();
    }

    const handleSave = () => {
        const args = {
            tags,
            people,
            locations
        }
        setLocalAssets(assets)
        setViewState('saving');

    }

    const handleDelete = () => {
        setLocalAssets(assets)
        setViewState('deleting');
    }

    const updateAssets = async () => {
        const id = Object.keys(localAssets)[0];
        updateSingleAsset(localAssets[id]);
    }

    const deleteAssets = async () => {
        const id = Object.keys(localAssets)[0];
        // deleteSingleAsset(localAssets[id]);
        dispatch(deleteAsset(id));
    }

    const updateSingleAsset = async (asset) => {

        let success = true;
        // Tags
        if (tags.length > 0) {
            const resTags = await addGenericTags("Asset", asset.id, tags)
            if (resTags.status !== 'success') success = false;
        }

        // People
        if (people.length > 0) {
            const resPeople = await addPeopleTags("Asset", asset.id, people)
            if (resPeople.status !== 'success') success = false;
        }

        // Locations
        if (locations.length > 0) {
            const resLocation = await addLocationTags("Asset", asset.id, locations)
            if (resLocation.status !== 'success') success = false;
        }

        if (success === true) {
            // Remove This From The Local Array
            const newLocal = { ...localAssets };
            delete newLocal[asset.id];
            setLocalAssets(newLocal);
        }
    }

    useEffect(() => {
        if (store?.deleteSuccess) {
            const newLocal = { ...localAssets };
            delete newLocal[store.delete.id];
            setLocalAssets(newLocal);
        }
    }, [store?.delete])

    useEffect(() => {
        if (viewState === 'edit') return;
        if (viewState === 'delete') return;
        if (Object.keys(localAssets).length === 0) {
            onComplete()
        } else if (viewState === 'saving' && Object.keys(localAssets).length > 0) {
            updateAssets();
        } else if (viewState === 'deleting' && Object.keys(localAssets).length > 0) {
            deleteAssets();
        }
    }, [localAssets, viewState])

    // Guard
    if (myRole === 'viewer') return (<SmartContainer>You don't not have access to make changes.</SmartContainer>)

    const deleteDescription = "Move selected items to the trash.";
    const editDescription = "Adding tags will add to the existing tags on each Asset.";
    const description = (action === 'delete') ? deleteDescription : editDescription;

    return (
        <Stack>
            <StyledP light>{description}</StyledP>
            <Divider />

            {viewState === 'edit' && (
                <Stack>
                    <Stack>
                        <TagSelectorWithAutoComplete noLabels={true} inputLabel="Search for a person" existingOptions={people} staticOptions={storePeople?.fulldataset?.rows} selector={FullPeople} action={searchPeople} onChange={setPeople} renderOption={(props, option) => (<IconSuggestionBox icon={<IconPerson />} label={option.name} {...props} />)} />
                        {/* <TagSelector noLabels={true} inputLabel="Search for a person" existingOptions={people} options={storePeople?.fulldataset?.rows} onChange={setPeople} renderOption={(props, option) => (<IconSuggestionBox icon={<IconPerson />} label={option.name} {...props} />)} /> */}
                    </Stack>
                    <Stack>
                        <TagSelectorWithAutoComplete noLabels={true} inputLabel="Search for a location" existingOptions={locations} staticOptions={storeLocations?.fulldataset?.rows} selector={FullLocations} action={searchLocations} onChange={setLocations} renderOption={(props, option) => (<IconSuggestionBox icon={<IconLocation />} label={option.name} {...props} />)} />
                        {/* <TagSelector noLabels={true} inputLabel="Search for a location" existingOptions={locations} options={storeLocations?.fulldataset?.rows} onChange={setLocations} renderOption={(props, option) => (<IconSuggestionBox icon={<IconLocation />} label={option.name} {...props} />)} /> */}
                    </Stack>

                    <Stack>
                        <TagSelectorWithAutoComplete noLabels={true} inputLabel="Search for tags" existingOptions={tags} staticOptions={storeTags?.fulldataset?.rows} options={storeTags?.fulldataset?.rows} onChange={setTags} selector={FullGenericTags} action={searchGenericTags} renderOption={(props, option) => (<IconSuggestionBox icon={<IconTag />} label={option.name} {...props} />)} />
                        {/* <TagSelector noLabels={true} inputLabel="Search for tags" existingOptions={tags} options={storeTags?.fulldataset?.rows} onChange={setTags} renderOption={(props, option) => (<IconSuggestionBox icon={<IconTag />} label={option.name} {...props} />)} /> */}
                    </Stack>

                    <HorizontalStack flex align="center" justify="flex-end">
                        <StyledButton onClick={handleCancel}>Cancel</StyledButton>
                        <StyledButton variant='contained' onClick={handleSave}>Save</StyledButton>
                    </HorizontalStack>
                </Stack>
            )}

            {viewState === 'delete' && (
                <Stack>
                    <SmartContainer><StyledH6>Are you sure?</StyledH6></SmartContainer>
                    <SmartContainer><StyledP>Are you sure you want to delete these assets?</StyledP></SmartContainer>


                    <HorizontalStack flex align="center" justify="flex-end">
                        <StyledButton onClick={handleCancel}>Cancel</StyledButton>
                        <StyledButton variant='contained' color="error" onClick={handleDelete}>Delete</StyledButton>
                    </HorizontalStack>
                </Stack>
            )}


            {(viewState === 'saving' || viewState === 'deleting') && (
                <Stack>
                    {Object.keys(localAssets).map(key => {
                        const asset = assets[key];

                        return (
                            <BatchUpdatePreview asset={asset} tags={tags} locations={locations} people={people} />
                        )
                    })}
                </Stack>
            )}

        </Stack>
    )
}